export const TransformToMonitorDict = monitorData => {
  let monitors = {};
  monitorData.forEach(row => {
    monitors[row.table_id] = row.random_id;
  });

  return monitors;
};
